import React from 'react';
import { BynIcon } from "../../ui/BynIcon";
import {IsMedicalIsNoveltyIsSale} from "../../../pages/cardSmallComponents/IsMedicalisNoveltyIsSale";

interface Props {
    price: string
    isPriceOld: boolean
    priceOld: string
    isSale: number
    isNovelty: boolean
    isMedical: boolean
}

export class PriceProductMobile extends React.Component<Props, {}> {


    componentDidMount() {
    }

    render() {

        let price: string = this.props.price
        let isPriceOld: boolean = this.props.isPriceOld
        let priceOld: string = this.props.priceOld
        let isSale: number = this.props.isSale
        let isNovelty: boolean = this.props.isNovelty
        let isMedical: boolean = this.props.isMedical

        let Width = window.innerWidth

        return (
            <div className="goods-content">
                <div className="goods-content-price">

                    {price ? <div>
                                            <span className="new-price" style={Width< 768 ? {fontSize: "1.1rem"}: {}}>{price} <BynIcon className="byn-icon--inline" />
                                                <sup >
                                                    <> {isPriceOld ?
                                                        <span  style={{textDecoration: "line-through", opacity: 0.5 }}>{priceOld} <BynIcon className="byn-icon--sup" /></span>
                                                        : null}
                                                    </>
                                                </sup>
                                            </span>

                        <span  >
                                                <IsMedicalIsNoveltyIsSale isSale={isSale}
                                                                          isNovelty={isNovelty}
                                                                          isMedical={isMedical}/>
                                            </span>

                        <div><small>цена указана без НДС</small></div></div> : null}
                </div>
            </div>
        )
    }
}

